import React  from 'react'
import {baseurl} from '../config/Settings';



function Header(props) { 
    return (
      <>
            <header id="main-header">
                    <div class="main-header-before">
                        <div class="grid-container">
                            <div class="main-header-before-content">
                                <div class="return-btn">
                                        {props.backhref ?  <a href={props.backhref}>
                                        <i class="icomoon-icon icon-arrow-right1"></i> الرجوع </a>  : "" }
                                </div>
                                <div class="logo">
                                    <a href={baseurl}><img src={`${baseurl}themes/custom/aawsatv3/assets/img/aawsat-logo-w-text.svg`} alt="Logo"/></a>
                                </div>
                                <div class="skip-btn">
                                  
                                    {props.skiphref ?   <a href={props.skiphref}>التخطي</a> : "" }
                                </div>
                            </div>
                        </div>
                    </div>
                </header> 


      </>
    );
  
}

export default Header;
